export enum RequestStatusEnum {
    All = 0,
    NewOrInProgres = 1,
    NewOrInProgressOrCompleted = 2,
    Archived = 3,
}
